/** CoStar.Api.ListingUser.ViewModels.DataRoomTask.Enums.DataRoomTaskType */
export var DataRoomTaskType;
(function (DataRoomTaskType) {
    DataRoomTaskType[DataRoomTaskType["None"] = 0] = "None";
    DataRoomTaskType[DataRoomTaskType["DocumentsAddedOrUpdatedAlertEmail"] = 1] = "DocumentsAddedOrUpdatedAlertEmail";
})(DataRoomTaskType || (DataRoomTaskType = {}));
/** CoStar.Api.ListingUser.ViewModels.DataRoomTask.Enums.DataRoomTaskStatus */
export var DataRoomTaskStatus;
(function (DataRoomTaskStatus) {
    DataRoomTaskStatus[DataRoomTaskStatus["None"] = 0] = "None";
    DataRoomTaskStatus[DataRoomTaskStatus["Submitted"] = 1] = "Submitted";
    DataRoomTaskStatus[DataRoomTaskStatus["ClaimedForProcessing"] = 2] = "ClaimedForProcessing";
    DataRoomTaskStatus[DataRoomTaskStatus["ListingDetailNotFound"] = 3] = "ListingDetailNotFound";
    DataRoomTaskStatus[DataRoomTaskStatus["ContactDetailNotFound"] = 4] = "ContactDetailNotFound";
    DataRoomTaskStatus[DataRoomTaskStatus["ErrorWhileProcessingTheTask"] = 5] = "ErrorWhileProcessingTheTask";
    DataRoomTaskStatus[DataRoomTaskStatus["ErrorWhileSendingTheEmail"] = 6] = "ErrorWhileSendingTheEmail";
    DataRoomTaskStatus[DataRoomTaskStatus["Completed"] = 7] = "Completed";
    DataRoomTaskStatus[DataRoomTaskStatus["InvalidData"] = 8] = "InvalidData";
    DataRoomTaskStatus[DataRoomTaskStatus["Deferred"] = 9] = "Deferred";
})(DataRoomTaskStatus || (DataRoomTaskStatus = {}));
